<template>
<div class="chapter">
<div class="inner_page">
<p class="h1l" id="d7e194220">I Will </p>
<table border="0" class="table"><colgroup><col/><col/></colgroup><tbody><tr><td>Pray for wisdom to know when I should practice patience.</td><td>yes </td><td>no</td></tr><tr><td>Ask God for patience when I know it’s needed in a given situation.
</td><td>yes </td><td>no</td></tr><tr><td>Expect to find myself in situations where patience is required.
</td><td>yes </td><td>no</td></tr><tr><td>Know that everyone faces the challenge of learning to be patient.
</td><td>yes </td><td>no</td></tr><tr><td>Learn from past experience how impatience leads to division.
</td><td>yes </td><td>no</td></tr><tr><td>Look at Paul’s example to learn how to develop patience.
</td><td>yes </td><td>no</td></tr></tbody></table><p class="h1l" id="d7e194920">Things to Do </p>
<p class="ul" id="d7e196920"><img alt="bu" src="images/bu.jpg" style="max-width: 100%;"/><i> Review a recent experience that challenged your patience and examine </i><i>what made being patient so difficult.</i></p>
<p class="ul" id="d7e197820"><img alt="bu" src="images/bu.jpg" style="max-width: 100%;"/><i> Identify a coworker, family member, or friend and observe how this </i><i>person handles patience.</i></p>
<p class="ul" id="d7e198720"><img alt="bu" src="images/bu.jpg" style="max-width: 100%;"/><i> Participate in an activity once (such as playing a board game with </i><i>friends) that gives you a chance to practice patience.</i></p>
<p class="ul" id="d7e199520"><img alt="bu" src="images/bu.jpg" style="max-width: 100%;"/><i> List three everyday opportunities you have to practice patience (while </i><i>shopping, working, sharing a meal with friends).</i></p>
<p class="ul" id="d7e200420"><img alt="bu" src="images/bu.jpg" style="max-width: 100%;"/><i> Write a letter to God asking for more patience.</i></p>
<p class="ul" id="d7e200920"><img alt="bu" src="images/bu.jpg" style="max-width: 100%;"/><i> Talk with a friend you respect about how he or she practices patience.</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Inc_9781418557720_epub_c15_r1.vue?196c85a2